var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({ref:"field",attrs:{"outlined":"","dense":"","label":"Company","clearable":"","loading":_vm.companiesStatus === 'loading',"item-text":"name","item-value":"id","value":_vm.model,"items":_vm.filteredCompanies,"persistent-hint":""}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }